<template>
  <div v-if="visible" class="cs-emoji-pop" @mousedown.stop>
    <div class="cs-emoji-grid">
      <button
        v-for="item in emojis"
        :key="item"
        type="button"
        class="cs-emoji-btn"
        @click="$emit('select', item)"
      >{{ item }}</button>
    </div>
  </div>
</template>

<script>
const EMOJIS = [
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
  '🙂', '😉', '😍', '🥰', '😘', '😗', '😋', '😛', '😜', '🤪',
  '🤗', '🤭', '🤫', '🤔', '😐', '😑', '😶', '🙄', '😏', '😣',
  '😮', '😯', '😪', '😫', '🥱', '😴', '😌', '🤤', '😒', '😓',
  '😔', '😕', '🙃', '😲', '🙁', '😖', '😞', '😟', '😤', '😢',
  '😭', '😨', '😩', '🤯', '😬', '😰', '😱', '🥵', '🥶', '😳',
  '😵', '😡', '😠', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🥳',
  '🥺', '🤠', '🤡', '😈', '👻', '💀', '🤖', '💩', '👍', '👎',
  '👏', '🙌', '🙏', '💪', '🤝', '✌️', '🤞', '👌', '🤙', '👋',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💔', '💕', '✨',
  '⭐', '🔥', '💯', '🎉', '🎊', '✅', '❌', '⚠️', '💬', '📌'
]

export default {
  name: 'CsEmojiPicker',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { emojis: EMOJIS }
  }
}
</script>

<style lang="scss" scoped>
.cs-emoji-pop {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  width: min(320px, calc(100vw - 32px));
  max-height: 220px;
  overflow-y: auto;
  padding: 10px;
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(17, 24, 39, 0.14);
  z-index: 20;
}
.cs-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 2px;
}
.cs-emoji-btn {
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  &:hover {
    background: #f3f4f6;
  }
}
</style>
